import { createUseStyles } from 'react-jss';

export default createUseStyles<'headerContainer'>({
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: 10,
  },
});
